module.exports = __webpack_public_path__ + "img/01.50b1d40b.png";